import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getCanonicalAffiliateName } from "../lib/affiliateIdentity";

// Guards the CSV/Excel upload page. Mirrors the server-side gate
// (public.can_upload_performance_data()): payment admins, media buyers
// (role blanket), or a per-user profiles.can_upload grant. The database
// wrapper enforces the same rule, so this guard is UX only — bypassing it
// just gets a 42501 from the RPC.
const ProtectedUploadRoute = () => {
  const { user, profile, isAdmin, isMediaBuyer, loading, isRoleLoading } =
    useAuth();

  if (loading || isRoleLoading || (user && !profile)) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const allowed = isAdmin || isMediaBuyer || profile?.can_upload === true;

  if (!allowed) {
    const affiliateName = getCanonicalAffiliateName(profile, user);
    return <Navigate to={`/affiliate/${affiliateName}`} />;
  }

  return <Outlet />;
};

export default ProtectedUploadRoute;
